import React, { useEffect, useState } from "react";
import "./ActivityStatus.css";
import { getChangeStatusById } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import DataTable from "../../../components/common/DataTable/DataTable";
import Spinner from "../../Spin/Spinner";
import CopyCell from "../../../components/common/TableCells/CopyCell";

const ActivityStatusPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [transationId, setTransactionId] = useState("");
  const token = useSelector((state) => state.userReducer.token);

  const fetchChangeStatusReport = async (currentPage, transationId) => {
    try {
      setLoading(true);
      const response = await getChangeStatusById(
        token,
        transationId,
        currentPage,
      );
      setStatusData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch status.");
    }
  };
  useEffect(() => {
    if (transationId !== "") {
      const delayDebounce = setTimeout(() => {
        fetchChangeStatusReport(1, transationId);
      }, 2000);
      return () => clearTimeout(delayDebounce);
    }
  }, [transationId]);

  useEffect(() => {
    if (transationId === "") {
      fetchChangeStatusReport(currentPage, "");
    }
  }, [currentPage, transationId]);

  const handleTransactionIdChange = (e) => {
    setTransactionId(e.target.value);
  };

  const columns = [
    {
      key: "merchantName",
      header: "Merchant Name",
      wrapCell: true,
    },
    {
      key: "pg",
      header: "PG",
    },
    {
      key: "type",
      header: "Type",
    },
    {
      key: "amount",
      header: "Amount (₹)",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "orderId",
      header: "Order Id",
      wrapCell: true,
      render: (row) => <CopyCell value={row.orderId} />,
    },
    {
      key: "transactionId",
      header: "Transaction Id",
      wrapCell: true,
      render: (row) => <CopyCell value={row.transactionId} />,
    },
    {
      key: "changedBy",
      header: "Changed By",
      wrapCell: true,
    },
    {
      key: "date",
      header: "Date",
      wrapCell: true,
    },
  ];

  const formattedData =
    statusData?.map((item) => {
      const isLogs = !!item.logs;

      const dynamicKey = isLogs
        ? Object.keys(item.logs)[0]
        : Object.keys(item).find(
            (key) =>
              key !== "_id" &&
              key !== "createdAt" &&
              key !== "updatedAt" &&
              key !== "__v",
          );

      const logData = isLogs ? item.logs[dynamicKey] : item[dynamicKey];

      return {
        merchantName: logData?.alias || logData?.userId || "N/A",
        pg: logData?.pg || "N/A",
        type: logData?.type || "N/A",
        amount: logData?.amount || "N/A",
        status: logData?.status || "N/A",
        orderId: dynamicKey || "",
        transactionId: logData?.transactionId || "",
        changedBy: logData?.changedBy || "N/A",
        date: new Date(item?.updatedAt).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }),
      };
    }) || [];

  return (
    <div className="activity-status-table-container">
      <div className="activity-status-heading">
        <h2 className="activity-status-table-title">Change Status Report</h2>
        <input
          className="activity-input-field-container"
          type="text"
          placeholder="Order ID"
          value={transationId}
          onChange={handleTransactionIdChange}
        />
      </div>
      <div>
        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={formattedData}
            emptyMessage="No data found."
          />
        )}
      </div>
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default ActivityStatusPage;
